import request from '@/utils/request';

/**
 * 获取权限列表（分页）
 */
export function getPermissionList(params) {
  return request({
    url: '/rbac/permissions',
    method: 'get',
    params,
  });
}

export function getMyPermissions() {
  return request({
    url: '/rbac/permissions/my_permissions',
    method: 'get',
  });
}

/**
 * 获取所有权限列表（不分页）
 */
export function getAllPermissions() {
  return request({
    url: '/rbac/permissions/all',
    method: 'get',
  });
}

/**
 * 创建权限
 */
export function createPermission(data) {
  return request({
    url: '/rbac/permissions',
    method: 'post',
    data,
  });
}

/**
 * 更新权限
 */
export function updatePermission(id, data) {
  return request({
    url: `/rbac/permissions/${id}`,
    method: 'put',
    data,
  });
}

/**
 * 删除权限
 */
export function deletePermission(id) {
  return request({
    url: `/rbac/permissions/${id}`,
    method: 'delete',
  });
}
